export default "__VITE_ASSET__DJyJWNrB__"